<template>
  <BaseModal
      v-if="isOpen"
      :title="title"
      @close="emit('close')"
  >
    <div class="text-center">
      <div class="mb-3">
        {{ text }}
      </div>

      <div class="d-flex justify-content-center gap-3">
        <button class="btn btn-danger btn-lg w-25" @click="emit('accept')">
          Да
        </button>

        <button class="btn btn-primary btn-lg w-25" @click="emit('close')">
          Нет
        </button>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from "@/components/ui/components/BaseModal.vue";

const props = defineProps({
  title: { type: String, required: false },
  text: { type: String, required: false },
  isOpen: { type: Boolean, required: true },
});
const emit = defineEmits(['accept', 'close']);

</script>
